module.exports = [
 {
  "start": 83,
  "end": 3667,
  "text": "Meditation for suburb brain is about the beauty of garbage, "
 },
 {
  "start": 3708,
  "end": 5417,
  "text": "the beauty of the over looked. "
 },
 {
  "start": 5708,
  "end": 10125,
  "text": "I call these packagings with no prints instant diamonds"
 },
 {
  "start": 10417,
  "end": 14458,
  "text": "Can you imagine all the production steps and meetings for each package"
 },
 {
  "start": 14625,
  "end": 18000,
  "text": "Looking at this collection is calming my mind"
 },
 {
  "start": 18208,
  "end": 23291,
  "text": "The contemporary civilisation is producing endless containers to keep things clean "
 },
 {
  "start": 23333,
  "end": 27583,
  "text": "and separated in while in the same time these products are littering the world. "
 },
 {
  "start": 27708,
  "end": 32583,
  "text": "This work is symbolizing the contradictions of today’s civilisation."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room1/audio1/01_MCA Meditation for Suburb Brain.js